import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=15697634&scoped=true"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"
import style0 from "./Finish.vue?vue&type=style&index=0&id=15697634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15697634",
  null
  
)

export default component.exports